import React from 'react'
import './theme.scss'
import './app.scss'
import './swiper.bundle.scss'
import BaseLayout from './layout/base-layout'

import { renderRoutes } from 'react-router-config'
import routes from '../routes/c-log'

import { IntlProvider } from 'react-intl'
import { getMessage, getLocale } from '../i18n'

import { useSelector } from 'react-redux'


import SwiperCore, {
	Pagination,
	Autoplay
} from 'swiper'

SwiperCore.use([Pagination, Autoplay])

const Index = props => {

	const global = useSelector((state) => state.global)

	return <IntlProvider messages={getMessage(global.language)} locale={getLocale(global.language)} defaultLocale="en">
        <BaseLayout>
            {renderRoutes(routes)}
        </BaseLayout>
	</IntlProvider>

}


export default Index